import { useEffect, useState } from 'react';

/**
 * A `Date.now()` value that re-renders the caller on a fixed interval (default
 * 1s) — drives countdowns, elapsed clocks, and close detection without
 * threading a clock through props. Hoisted from SnakeMarkets once it grew
 * cross-feature consumers (countdown badge, live badge, portfolio).
 */
export function useNowMs(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
